export const getAbsoluteUrl = (url: string): string => {
  return !/^https?:\/\//i.test(url) ? `https://${url}` : url;
};
